import { render, staticRenderFns } from "./campaigns-table.vue?vue&type=template&id=d2c0a97e"
import script from "./campaigns-table.vue?vue&type=script&lang=js"
export * from "./campaigns-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports